import fetch from './fetch';

import { ENV } from '../settings/env';
import { CART_CDC_URLS, CART_PDC_URLS } from '../settings/cart';

export function getCart() {
  const urls = [CART_CDC_URLS[ENV], CART_PDC_URLS[ENV]];
  return Promise
    .all(urls.map(url => fetch(url, {}, 'cdc')))
    .then(responses => responses.map(response => response.json()))
    .then(promises => Promise.all(promises));
}



// WEBPACK FOOTER //
// ./src/services/cart.js